/*------------------------------------*\
    MODULES
\*------------------------------------*/
// import $ from "jquery";
import AOS from 'aos';

/*------------------------------------*\
    FADE SCROLL MODULE
\*------------------------------------*/
class fadeScroll {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        self.fade();
    }

    fade() {
        let self = this;
        AOS.init();

    }
}

export default fadeScroll;